import type { ScatterDataPoint } from 'chart.js';
import { ThreePhase } from '../../../../../../../utils/meterValues';
import { LLMServerModel } from './LLMServerModel';

export class LLMSupplyCurrentModel extends LLMServerModel {
  getDatum(args: { phase: ThreePhase }): ScatterDataPoint {
    const { phase } = args;
    return {
      x: new Date(this.serverEventDate).getTime(),
      y: this.server.SupplyCurrent ? this.server.SupplyCurrent[phase] : 0,
    };
  }
}
